/// <reference path="WebService.ts" />

interface WebService
{
    nextDocumentID( entityName: string, entityType: number, completion:any ) : void ;
    nextDocumentIDFromSequence( sequence:NumberSerialSequence, completion:any ) : void ;
}

WebService.prototype.nextDocumentID = function ( entityName: string, entityType: number, completion:any )
{
    const url = this.apiURL + "/entity/" + this.scheme + "/nextDocumentID/" + entityName + "/" + entityType.toString();
    let r = new DLRequest(url, null, "GET");
    r.execute(function(json, error) {            
        if (json != null && json["documentID"] != null) {
            completion(json["documentID"], json["documentPrefix"], json["documentNumber"], null);
        }
        else {
            completion(null, null, null, "Something went wrong!");
        }
    });
}

WebService.prototype.nextDocumentIDFromSequence = function ( sequence:NumberSerialSequence, completion:any ) 
{
    const url = this.apiURL + "/entity/" + this.scheme + "/next-document-id-from-sequence/" + sequence.identifier;
    let r = new DLRequest(url, null, "GET");
    r.execute(function(json, error) {            
        if (json != null && json["documentID"] != null) {
            completion(json["documentID"], json["documentPrefix"], json["documentNumber"], null);
        }
        else {
            completion(null, null, null, "Something went wrong!");
        }
    });
}